module.exports = {
  schema: {
    name: '片種價格區間管理',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '價格區間代碼',
        unique: true,
      },
      productRef: {
        type: 'ObjectId',
        reference: 'products',
        refKeys: ['key'],
        name: '商品代碼',
        input: 'select',
      },
      range: {
        type: 'Array', // [ { s: 1000, c: 0 }, ... ]
        name: '價格區間',
      },
      note: {
        type: 'String',
        name: '區間說明',
        input: 'textarea',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
    createdAt: {
      key: {
        '@@createdAt': 1,
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 150 },
        { key: 'productRef', width: 150 },
        { key: 'note', width: 300 },
      ],
    },
    editor: {
      config: { titleMd: 2 },
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'productRef' }],
            [{ key: 'note' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/priceRanges.js